import React, { Component, Fragment } from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';

class BatchSettlementReportIframe extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Fragment>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `.react-page { height: 100% }`,
          }}
        />
        <iframe
          title="batch settlement report"
          src={`/webapps_redirect.php?app=payments-reports&next=${encodeURIComponent(
            `${window.location.pathname}${window.location.search}`
          )}`}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </Fragment>
    );
  }
}

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(BatchSettlementReportIframe))
);
